import styled from "styled-components";

export const StylesTable = styled.table`
  th,
  td {
    border: none;
  }
  tr:nth-child(2n) {
    background-color: rgba(0, 0, 0, 0.03);
  }
`;

export const StylesPieChartLable = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  span {
    line-height: 14px;
    margin-left: 4px;
  }
`;

export const bgColor = [
  "rgba(255, 99, 132, 0.5)",
  "rgba(54, 162, 235, 0.5)",
  "rgba(255, 206, 86, 0.5)",
  "rgba(75, 192, 192, 0.5)",
  "rgba(153, 102, 255, 0.5)",
  "rgba(255, 159, 64, 0.5)",
  "rgba(201, 203, 207, 0.5)",
]

export const borderColor = [
  "rgb(255, 99, 132)",
  "rgb(54, 162, 235)",
  "rgb(255, 206, 86)",
  "rgb(75, 192, 192)",
  "rgb(153, 102, 255)",
  "rgb(255, 159, 64)",
  "rgb(201, 203, 207)",
];

export const StylesStatistics = styled.div`
  background: #f0f2f5;
  padding: 4rem;
  .MuiChip-root {
    height: 20px;
  }
  @media only screen and (max-width: 600px) {
    padding: 1rem;
  }
  h1 {
    margin-bottom: 64px;
  }
  .row {
    gap: 32px;
  }
  .bg-gradient-dark {
    background-image: linear-gradient(195deg, #42424a, #191919);
  }
  .bg-gradient-primary {
    background-image: linear-gradient(195deg, #ec407a, #d81b60) !important;
  }
  .bg-gradient-success {
    background-image: linear-gradient(195deg, #66bb6a, #43a047) !important;
  }
  .bg-gradient-info {
    background-image: linear-gradient(195deg, #49a3f1, #1a73e8) !important;
  }
  .bg-primary {
    background-color: rgb(0, 123, 255) !important;
  }
  .bg-info {
    background-color: #07cff9 !important;
  }
  .bg-warning {
    background-color: rgb(255, 193, 7) !important;
  }
  .warning {
    color: rgb(255, 193, 7) !important;
  }
  .danger {
    color: red !important;
  }
  .bg-success {
    background-color: rgb(40, 167, 69) !important;
  }
  .bg-secondary {
    background-color: rgb(108, 117, 125) !important;
  }
  .bg-purple {
    background-color: rgb(147, 112, 219) !important;
  }
  .purple {
    color: rgb(147, 112, 219) !important;
  }
  .text-purple {
    color: rgb(147, 112, 219) !important;
  }

  .legend-section {
    border-bottom: 1px solid #ccc; /* Add a bottom border */
    margin-bottom: 20px; /* Add margin at the bottom for separation */
    padding-bottom: 20px; /* Add padding at the bottom for space */
  }

  .bg-pink {
    background-color: rgb(255, 105, 180) !important;
  }
  .success {
    color : rgb(40, 167, 69)
  }
  button : hover {
    color : white
  }
  select {
    width : 100px
  }
  .card-transform {
    transition: transform ease 200ms;
    &:hover {
      transform: translate(0, -15px);
    }
  }
  .statistic-card {
    margin-bottom: 32px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
    background: #fff;
    padding: 16px;
    border-radius: 10px;
    &--header {
      padding-bottom: 1rem;
      color: #5f5c5c;
    }
    .dark_horizontal {
      background-image: linear-gradient(
        90deg,
        transparent,
        rgba(0, 0, 0, 0.4),
        transparent
      );
      border-top: none;
      height: 1px;
      opacity: 0.25;
      background-color: transparent;
      margin-right: 0;
      margin-left: 0;
    }
    &--footer {
      padding-top: 16px;
    }
    .loading {
      svg {
        animation-name: spin;
        animation-duration: 2000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
      }
    }
    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    &--icon {
      border-radius: 0.75rem;
      width: 50px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: linear-gradient(195deg, #42424a, #191919);
      background-position: 50%;
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14),
        0 7px 10px -5px rgba(64, 64, 64, 0.4) !important;
      text-align: center !important;
      margin-top: -2.5rem !important;
      position: absolute !important;
      fill: currentColor;
      stroke: none;
      color: #111;
    }
  }
  .refresh-button {
    color: black; 
    border: none;
    padding: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: color 0.3s; 
  }
  
  .refresh-button:hover {
    color: white; 
  }
`;
